import insightsClient from 'search-insights';

import { getAlgoliaEventProps, mountAlgoliaEvent } from './utils';

export const sendPdpClickEvent = async () => {
  const { userId, algoliaInsights, shouldSendEventToAlgolia } =
    getAlgoliaEventProps();

  if (shouldSendEventToAlgolia && algoliaInsights) {
    const event = {
      ...mountAlgoliaEvent(algoliaInsights, userId),
      eventName: 'clicked_pdp',
      positions: [algoliaInsights.position],
    };

    insightsClient('clickedObjectIDsAfterSearch', event);
  }
};

export const sendAddToCartEvent = () => {
  const { userId, algoliaInsights, shouldSendEventToAlgolia } =
    getAlgoliaEventProps();

  if (shouldSendEventToAlgolia && algoliaInsights) {
    const event = {
      ...mountAlgoliaEvent(algoliaInsights, userId),
      eventName: 'addToCart',
      eventSubType: 'addToCart',
      objectData: [
        {
          price: algoliaInsights.price,
          quantity: algoliaInsights.quantity,
        },
      ],
      currency: algoliaInsights.currency,
    };

    insightsClient('convertedObjectIDsAfterSearch', event);
  }
};
